<template>
<div>
    <sav-template :back-button="false"></sav-template>
</div>
</template>

<script>
export default {
    mounted() {
        localStorage.clear()
        this.$router.options.routes.forEach(route => {
            if (route.name == 'welcome') {
                window.location = route.path;
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/default/views/user/Logout.vue